import { UpPacketEnd } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

/**
 * Sends a GET request to retrieve the signed URL.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const signedUrl = async (data: signedData): Promise<signedResponse> =>
    APIManager.sendPost(UpPacketEnd.SIGNED_RESOURCE, data, true, {}, {}, axios);

/**
 * Sends a GET request to retrieve the upload history.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const uploadHistory = async (data: any): Promise<any> =>
    APIManager.sendGetWithBody(UpPacketEnd.UPLOAD_HISTORY, data, true, axios);

/**
 * Sends a POST request to upload a packet.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const uploadPacket = async (data: any): Promise<any> =>
    APIManager.sendPost(UpPacketEnd.UPLOAD, data, true, {}, {}, axios);

// Upload Services
export const UploadService = {
    signedUrl,
    uploadHistory,
    uploadPacket,
};
